import { MerchantDto, OrderTypeDto, OrderTypeNameEnum } from '@up/data';
import { ScheduleMap } from '@up/shared/interfaces';
import { getKeyByValue } from '../extensions/map.helper';
import { isStoreOpen } from '../merchant/schedule.helper';

export function isOrderTypeAvailable(
  availableOrderTypes: OrderTypeDto[],
  orderTypeName: string,
  merchant: MerchantDto,
  isOrderAtTable: boolean,
  isCatering: boolean,
  scheduleMap: ScheduleMap,
  isDeliveryEnabled: boolean,
  isCollectionEnabled: boolean,
  isOrderAtTableEnabled: boolean,
  isCollectionKerbSideEnabled: boolean,
  isAllowPreorder: boolean
) {
  const scheduleKey = getKeyByValue(OrderTypeNameEnum, orderTypeName);
  if (!availableOrderTypes || availableOrderTypes.length === 0 || !merchant) {
    return false;
  }

  switch (orderTypeName) {
    case OrderTypeNameEnum.DELIVERY: {
      const isDeliveryAvailable =
        availableOrderTypes?.some(
          orderType => orderType.name === orderTypeName
        ) &&
        isDeliveryEnabled &&
        !isOrderAtTable;

      if (!scheduleMap || isAllowPreorder) {
        return isDeliveryAvailable;
      }

      return (
        isDeliveryAvailable &&
        scheduleMap[scheduleKey].isAvailable &&
        isStoreOpen(scheduleMap[scheduleKey], new Date())
      );
    }
    case OrderTypeNameEnum.COLLECTION: {
      const isCollectionAvailable =
        availableOrderTypes?.some(
          orderType => orderType.name === orderTypeName
        ) &&
        isCollectionEnabled &&
        !isOrderAtTable;

      if (!scheduleMap || isAllowPreorder) {
        return isCollectionAvailable;
      }

      return (
        isCollectionAvailable &&
        scheduleMap[scheduleKey].isAvailable &&
        isStoreOpen(scheduleMap[scheduleKey], new Date())
      );
    }
    case OrderTypeNameEnum.TABLE: {
      return (
        availableOrderTypes?.some(
          orderType => orderType.name === orderTypeName
        ) &&
        isOrderAtTableEnabled &&
        isOrderAtTable &&
        (!scheduleMap ||
          (scheduleMap[scheduleKey].isAvailable &&
            isStoreOpen(scheduleMap[scheduleKey], new Date())))
      );
    }
    case OrderTypeNameEnum.KERB: {
      return (
        availableOrderTypes?.some(
          orderType => orderType.name === orderTypeName
        ) &&
        isCollectionKerbSideEnabled &&
        !isOrderAtTable &&
        !isCatering &&
        (!scheduleMap ||
          (scheduleMap[scheduleKey].isAvailable &&
            isStoreOpen(scheduleMap[scheduleKey], new Date())))
      );
    }
    default:
      return true;
  }
}
